// @flow
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Button } from 'semantic-ui-react';
import type { AcfFields } from '../types/personas';

import { Link } from 'react-router-dom';

type Props = {
  colour: string,
  image: string,
  title: string,
  summary: string,
  communityImageGallery: [
    {
      url: string,
      alt: string,
      title: string
    }
  ],
  personas: [],
  acf: AcfFields,
  communitySlug: string,
  slug: string
};

class CommunityTile extends React.Component<Props> {
  render() {
    const {
      colour,
      image,
      title,
      summary,
      personas,
      communitySlug
    } = this.props;

    return (
      <div className="community-tile" style={{ backgroundColor: colour }}>
        <img className="community-tile__image" src={image} alt="" />
        <div className="community-tile__text">
          <h4>{ReactHtmlParser(title.replace('-', '<br/>'))}</h4>
          <div className="community-tile__text-wrapper">
            {ReactHtmlParser(summary)}
          </div>
          <div
            className="community-tile__button-container"
            style={{ color: colour }}
          >
            <Button
              className="button--hollow"
              as={Link}
              to={`/${communitySlug}`}
            >
              Explore
            </Button>
          </div>
        </div>
        <div className="community-tile-menu">
          {personas &&
            personas
              .slice(0)
              .sort((a, b) => {
                // non-anonymous as you ordered...
                return b.acf.personacommunityNumber <
                  a.acf.personacommunityNumber
                  ? 1 // if b should come earlier, push a to end
                  : b.acf.personacommunityNumber > a.acf.personacommunityNumber
                  ? -1 // if b should come later, push a to begin
                  : 0; // a and b are equal
              })
              .map((persona, key) => (
                <div
                  key={key}
                  className="community-title-menu__persona-link community-tile__modal"
                >
                  <Link
                    to={
                      communitySlug +
                      '/' +
                      persona.acf.personacommunityNumber +
                      '-' +
                      persona.acf.title
                        .toLowerCase()
                        .replace(' - ', '-')
                        .replace(' ', '-')
                        .replace(' ', '-')
                        .replace(' ', '-')
                    }
                  >
                    <div className="community-tile-menu__link">
                      <span className="community-tile-menu__number">
                        {persona.acf.personacommunityNumber}
                      </span>
                      <span className="community-tile-menu__name">
                        {persona.acf.title}
                      </span>
                    </div>
                  </Link>
                </div>
              ))}
        </div>
      </div>
    );
  }
}

export default CommunityTile;
